import { BrowserRouter } from "react-router-dom";
import Routes from "./routers";
import { useEffect, useState } from "react";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import type { Locale } from "antd/es/locale";
import { ConfigProvider } from "antd";
import useLanguage from "@/hooks/useLanguage";
import i18next from "i18next";

import dayjs from "dayjs";

import "dayjs/locale/zh-cn";

export default function Router() {
  const { language } = useLanguage();
  const [locale, setLocal] = useState<Locale>(() => {
    if (language) {
      language === "en" ? dayjs.locale("en") : dayjs.locale("zh-cn");
      if (language === "en") return enUS;
      if (language === "zh") return zhCN;
    } else {
      dayjs.locale("zh-cn");
      return zhCN;
    }
  });
  useEffect(() => {
    i18next.on("languageChanged", (lng) => {
      setLocal(lng === "en" ? enUS : zhCN);
      lng === "en" ? dayjs.locale("en") : dayjs.locale("zh-cn");
    });
  }, []);
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        components: {
          Result: {
            titleFontSize: 16,
            iconFontSize: 32,
          },
        },
      }}
    >
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </ConfigProvider>
  );
}
